import request from "./http";
import qs from 'qs'

// 	 * 班组管理->获取所有班组列表
export function getTeamstGroups(params) {
    return request({
        url: "/classTeam/getByUnit",
        method: "get",
        params
    });
}

// 	 * 班组管理->获取已启用的班组列表
export function getByUnitAndIsCheck(params) {
    return request({
        url: "/classTeam/getByUnitAndIsCheck",
        method: "get",
        params
    });
}


// 	 * 班组管理->新增或修改班组
//  className 班组名称
//  startTime 开始时间
//  endTime 结束时间
//  isCheck 是否启用: 0-禁用，1-启用
//  unitId 单位id
//  uid 修改的时候才需要传

export function setClassTeamSave(params) {
    return request({
        url: "/classTeam/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}

// 	 * 班组管理->根据班组Id删除班组
// 
export function deleteClassTeam(params) {
    return request({
        url: "/classTeam/delete",
        method: "delete",
        params
    });
}


// 	 * 班组能耗->根据班组Id删除班组
// 	 * 班组能耗->一个班组的时候
export function getByTeamIdAndTimes(params) {
    return request({
        url: "/classTeam/getByTeamIdAndTimes",
        method: "get",
        params
    });
}

// 	 * 班组能耗->多个班组同一时间查询
export function getByTeamIdsAndTimesAll(params) {
    return request({
        url: "/classTeam/getByTeamIdsAndTimes",
        method: "get",
        params
    });
}


